import { RightCircleOutlined, DownCircleOutlined } from "@ant-design/icons";
import ActionButtons from './ActionButtons'
import { Button, Input, Table, Select, Tooltip } from "antd";
import { useState, useEffect } from 'react';
import { InterventionFormItem } from "./InterventionFormItem";
import { nameKey } from '../../helpers'
import './style.css'

const { Column } = Table;

const InterventionsTable = ({ quarter, quarters, RecordList, secondaryAction, ...props }) => {

  const { form, add, name, active, setActive } = props

  const [expandedRowKey, setExpandedRowKey] = useState(undefined)
  const [roleAllowsCreation, setRoleAllowsCreation] = useState(false)

  useEffect(() => {
    (async () => {
      const userId = Weaver.getInstance().currentUser().id();
      const roles = await Weaver.Role.list();
      roles.forEach((role) => {
        if(role.name()==='InterventionCreator') {
          setRoleAllowsCreation(role.getUsers().indexOf(userId) > -1)
        }
      })
    })()
  }, [])

  const getColumns = () => ([
    {
      title: 'Naam',
      dataIndex: 'name',
      key: 'name',
      Component: Input,
      props: { }
    }, {
      title: 'Reden',
      dataIndex: 'reason',
      key: 'reason',
      Component: Input,
      props: { }
    }, {
      title: 'Documentnummer',
      dataIndex: 'docid',
      key: 'docid',
      Component: Input,
      props: { }
    }, {
      title: 'Kwartaal',
      dataIndex: 'qname',
      key: 'qname',
      Component: Select,
      props: {
        mode: 'multiple',
        disabled: (add === null) || (name === 'BBV'),
        style: { width: '100%' },
        options: parseQuarterList()
      }
    }
  ]);

  const parseQuarterList = () => {
    return quarters.map((quarterNode) => ({
      label: quarterNode.get(nameKey),
      value: quarterNode.id()
    }))
  }

  const addIntervention = () => {
    add({ qname: [quarter] })
    const index = form.getFieldsValue().interventions.length -1
    setActive(index)
  }

  return (
    <Table
      { ...props }
      footer={() => (add?
        <Tooltip title={roleAllowsCreation?'':'Vereist rol InterventionCreator'}>
          <Button
            disabled={!roleAllowsCreation}
            onClick={addIntervention}
            style={{ width: '100%' }}
          >
            Add Intervention
          </Button>
        </Tooltip>:null
      )}
      expandable={{
        expandRowByClick: false,
        expandedRowKeys: [expandedRowKey],
        expandedRowRender: (intervention, rowIndex) => (
          <RecordList
            rowIndex={rowIndex}
            options={parseQuarterList()}
            quarter={quarter}
            { ...props }
          />
        ),
        rowExpandable: (intervention) => true,
        expandIcon: ({ expanded, onExpand, record }) => {
          if (expanded) {
            return <DownCircleOutlined onClick={(e) => {
              setExpandedRowKey(undefined)
              onExpand(record, e)}
            }/>
          } else {
            return <RightCircleOutlined onClick={(e) => {
              setExpandedRowKey(record.key)
              onExpand(record, e)}
            }/>
          }
        }
      }}
      pagination={false}
    >
      { getColumns().map(({ title, dataIndex, key, Component, props }) => {
          return (
            <Column
              key={key}
              dataIndex={dataIndex}
              title={title}
              render={(value, row, index) => {
                return (
                  <InterventionFormItem
                    name={[index, key]}
                    editing={index === active}
                  >
                    <Component { ...props}/>
                  </InterventionFormItem>
                );
              }}
            />
        )
      })}
      <Column
        width={240}
        dataIndex=''
        title='Actions'
        render={(value, row, index) => (
          <ActionButtons
            setExpandedRowKey={setExpandedRowKey}
            secondaryAction={secondaryAction}
            rowIndex={index}
            editable={add !== null}
            { ...props }
          />
        )}
      />
    </Table>
  );
};

export default InterventionsTable
